<script>
	import { fly } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
	import Header from './components/Header.svelte';
	import Menu from './components/Menu.svelte';
	import Capture from './components/Capture.svelte';
	import CaptureExtension from './components/CaptureExtension.svelte';
	import CaptureProperty from './components/CaptureProperty.svelte';
	import Settings from './components/Settings.svelte';
	import About from './components/About.svelte';
	export let version;
	const CAPTURE_EXTENSION = 1;
	const SETTINGS = 2;
	const ABOUT = 3;
	const CAPTURE = 4;
	const CAPTURE_PROPERTY = 5;
	const menu = [
		{label: 'Capture', active:true, id: CAPTURE},
		{label: 'Capture Extension', id: CAPTURE_EXTENSION},
		{label: 'Capture Property', id: CAPTURE_PROPERTY},
		{label: 'Settings', id: SETTINGS},
		{label: 'About', id: ABOUT}
	];
	let menuActive = menu[0];
	let openMenu = false;

	const getYear = () => {
		const date = new Date();
		return date.getFullYear();
	}

	const onMenuClick = e => {
		console.log('click on ', e.detail.label);
		menuActive = e.detail;
	}

	const onOpenCloseMenu = ()=> {
		openMenu = !openMenu;
	}
</script>

<main>
	<header>
		<Header on:clickMenu={onOpenCloseMenu}/>
	</header>
	<div class="container">
		<div class="main-content">
			{#if menuActive.id === CAPTURE}
				<Capture />
			{:else if menuActive.id === CAPTURE_EXTENSION}
				<CaptureExtension />
				{:else if menuActive.id === CAPTURE_PROPERTY}
				<CaptureProperty />
			{:else if menuActive.id === SETTINGS}
				<Settings />
			{:else}
				<About />
			{/if}
		</div>
		<div class="side-menu">
			<Menu menuItems={menu} on:menuClick={onMenuClick} />
		</div>
		{#if openMenu}
		<div class="menu-smaller-screen" 
			transition:fly="{{delay: 0, duration: 500, x: 200, y: 0, opacity: 0.5,easing: quintOut}}">
			<Menu menuItems={menu} on:menuClick={onMenuClick} />
		</div>
		{/if}
</div>
	<footer>
		<div>
			&copy;{getYear()} Copyright Socket Mobile, inc. Version {version}
		</div>
	</footer>
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	header {
		height: 80px;
		width: 100%;
		background-color: #171717;
	}
	footer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		height: 40px;
		width: 100%;
		text-align: center;
		color: #FDFDFD;
		background-color: #D77C33;
	}
	footer div {
		opacity: 50%;
	}
	.container {
		flex: 1;
		display: flex;
		overflow: auto;
	}
	.main-content {
		flex: 1;
		overflow: auto;
	}
	.side-menu {
		width: 240px;
		background-color: #DDDDBE;
	}
	@media  screen and (max-width: 812px) {
		.side-menu {
			display: none;
		}
		.menu-smaller-screen {
			background-color: #DDDDBE;
		}
	}
</style>